// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const joltik: PokeData = {
  "id": 595,
  "name": "joltik",
  "height": 1,
  "weight": 6,
  "base_experience": 64,
  "types": [
    PokeType.BUG,
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "absorb",
    "string-shot",
    "thunder-wave",
    "agility",
    "screech",
    "leech-life",
    "slash",
    "spider-web",
    "fury-cutter",
    "signal-beam",
    "gastro-acid",
    "sucker-punch",
    "bug-buzz",
    "discharge",
    "bug-bite",
    "electro-ball",
    "electroweb"
  ],
  "moves": [
    "string-shot",
    "bug-buzz",
    "bug-bite",
    "pin-missile",
    "volt-switch",
    "zap-cannon",
    "lunge",
    "electric-wrath",
    "heal-order",
    "volt-crash",
    "thunder",
    "infest",
    "wild-charge"
  ],
  "evolution_chain": {
    "id": 303,
    "item": null,
    "species": [
      {
        "name": "joltik",
        "order": 596,
        "types": [
          PokeType.BUG,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "galvantula",
        "order": 597,
        "types": [
          PokeType.BUG,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 595,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 50,
    "speed": 65,
    "ability_power": 57
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
